import Cookies from 'js-cookie'
// import Masonry from 'masonry-layout';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgFullscreen from 'lightgallery/plugins/fullscreen'
import lgVideo from 'lightgallery/plugins/video'

var moveItItem = function(el){
  this.el = $(el);
  this.speed = parseInt(this.el.attr('data-scroll-speed'));
};

moveItItem.prototype.update = function(scrollTop){
  var pos = scrollTop / this.speed;
  this.el.css('transform', 'translateY(' + pos + 'px)');
};

$.fn.moveIt = function(){
  var $window = $(window);
  var instances = [];
  
  $(this).each(function(){
    instances.push(new moveItItem($(this)));
  });
  
  window.onscroll = function(){
    var scrollTop = $window.scrollTop();
    instances.forEach(function(inst){
      inst.update(scrollTop);
    });
  }
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth',
        });
    });
});

export default {
  init() {
    // JavaScript to be fired on all pages
    $(function(){
      $('[data-scroll-speed]').moveIt();

      var carousel_leftarrow = $('.arrow-templates:first .left').html();
      var carousel_rightarrow = $('.arrow-templates:first .right').html();
      $('.owl-carousel').owlCarousel({
        loop: true,
        margin: 0,
        stagePadding: 0,
        nav: true,
        dots: false,
        items: 1,
        autoplay: true,
        autoplayTimeout: 7500,
        stopOnHover: true,
        navText: [carousel_leftarrow, carousel_rightarrow],
      });

    //   if($('.grid').length !== 0) {
    //     new Masonry( '.grid', {
    //       itemSelector: 'article',
    //       // columnWidth: 10,
    //       percentPosition: true,
    //       gutter: 10,
    //     });
    //   }

        $('.history-back').on('click', function(event) {
            event.preventDefault();
            history.back();
        });


        lightGallery(document.getElementById('header-lightgallery'), {
            plugins: [lgZoom, lgThumbnail, lgFullscreen],
            speed: 500,
            selector: '.item',
            mousewheel: true,
            showCloseIcon: true,
            });

        lightGallery(document.getElementById('lightgallery'), {
            plugins: [lgZoom, lgThumbnail, lgFullscreen],
            speed: 500,
            mousewheel: true,
            showCloseIcon: true,
        });

        // lightGallery(document.getElementById('gallery-lightgallery'), {
        //     plugins: [lgZoom, lgThumbnail, lgFullscreen],
        //     speed: 500,
        //     mousewheel: true,
        //     showCloseIcon: true,
        //     selector: '.wp-block-image a',
        // });

        // var gallery_lightgallery = document.getElementsByClassName('gallery-lightgallery');
        // for (let i = 0; i < gallery_lightgallery.length; i++) {
        //     lightGallery(gallery_lightgallery[i], {
        //         plugins: [lgZoom, lgThumbnail, lgFullscreen],
        //         speed: 500,
        //         mousewheel: true,
        //         showCloseIcon: true,
        //         selector: '.wp-block-image a',
        //     });
        // }

        var gallery_lightgallery = document.getElementsByClassName('wp-block-gallery');
        for (let i = 0; i < gallery_lightgallery.length; i++) {
            if(
                !gallery_lightgallery[i].classList.contains('no-lightbox')
                ) {
                console.log('wp-block-gallery');
                console.log(gallery_lightgallery[i]);
                lightGallery(gallery_lightgallery[i], {
                    plugins: [lgZoom, lgThumbnail, lgFullscreen],
                    speed: 500,
                    mousewheel: true,
                    showCloseIcon: true,
                    selector: '.wp-block-image a',
                });
            }
        }

        var image_lightgallery = document.getElementsByClassName('wp-block-image');
        for (let i = 0; i < image_lightgallery.length; i++) {
            if (
                !image_lightgallery[i].parentNode.classList.contains('wp-block-gallery') && 
                !image_lightgallery[i].parentNode.classList.contains('no-lightbox')
                ) {
                console.log('wp-block-image');
                console.log(image_lightgallery[i]);
                lightGallery(image_lightgallery[i], {
                    plugins: [lgZoom, lgThumbnail, lgFullscreen],
                    speed: 500,
                    mousewheel: true,
                    showCloseIcon: true,
                    selector: 'a',
                });
            }
        }

        lightGallery(document.getElementById('gallery-videos'), {
            plugins: [lgVideo, lgThumbnail, lgFullscreen],
            speed: 500,
            mousewheel: true,
            showCloseIcon: true,
            videojs: true,
        });

        var gallery_videos = document.getElementsByClassName('gallery-videos');
        for (let i = 0; i < gallery_videos.length; i++) {
            lightGallery(gallery_videos[i], {
                plugins: [lgVideo, lgThumbnail, lgFullscreen],
                speed: 500,
                mousewheel: true,
                showCloseIcon: true,
                videojs: true,
            });
        }

        

        // pass click event back to slider
        if($('header .slider-wrapper').length !== 0) {
            $('header .woverloay').addClass('lightbox-open');
            $('header .woverloay').on('click', function(event) {
                event.preventDefault();
                $('header .owl-item.active img').trigger('click');
            });
        }
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    if(Cookies.get('southernack') === undefined) {
      $('.acknowledgement').addClass('displayack');
    }

    $('.acknowledgement').on('click', function() {
      $(this).removeClass('displayack');
      Cookies.set('southernack', 'shown', { expires: 30 });
    });




    if(document.getElementById('map')) {
        var position = {lat: -42.8825811, lng: 147.3258864};
        var map = new google.maps.Map(document.getElementById('map'), { // eslint-disable-line
        center: position, // lat: -42.880240, lng: 147.325510
        zoom: 14,
        disableDefaultUI: false,
        zoomControl: true, // false
        scaleControl: true,
        mapTypeControl: true,
        streetViewControl: true,
        rotateControl: true,
        fullscreenControl: true, // false
        mapTypeId: 'roadmap',
        gestureHandling: 'cooperative', // none
        styles: [
          {
              'featureType': 'all',
              'elementType': 'labels',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
              ],
          },
          {
              'featureType': 'administrative',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'landscape',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'poi',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'poi.attraction',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'poi.business',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'poi.government',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#dfdcd5',
                  },
              ],
          },
          {
              'featureType': 'poi.medical',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#dfdcd5',
                  },
              ],
          },
          {
              'featureType': 'poi.park',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#bad294',
                  },
              ],
          },
          {
              'featureType': 'poi.place_of_worship',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'poi.school',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'poi.sports_complex',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#efebe2',
                  },
              ],
          },
          {
              'featureType': 'road.highway',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#ffffff',
                  },
              ],
          },
          {
              'featureType': 'road.highway',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
              ],
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#ffffff',
                  },
              ],
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
              ],
          },
          {
              'featureType': 'road.local',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#fbfbfb',
                  },
              ],
          },
          {
              'featureType': 'road.local',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
              ],
          },
          {
              'featureType': 'transit',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
              ],
          },
          {
              'featureType': 'water',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#a5d7e0',
                  },
              ],
          },
        ],
      });



      new google.maps.Marker({ // eslint-disable-line
        position: position,
        map,
        title: 'Great Southern Dance',
      });


    }
  },
};
